import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "./utils"

const itemVariants = cva(
  "group flex items-center gap-4 p-4 rounded-md cursor-pointer transition-colors border border-transparent focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none",
  {
    variants: {
      variant: {
        default:
          "hover:bg-accent hover:text-accent-foreground data-[state=selected]:bg-accent data-[state=selected]:text-accent-foreground",
        ghost:
          "hover:bg-accent/50 hover:text-accent-foreground data-[state=selected]:bg-accent data-[state=selected]:text-accent-foreground",
      },
      disabled: {
        true: "opacity-50",
        false: "",
      },
    },
    defaultVariants: {
      variant: "default",
      disabled: false,
    },
    compoundVariants: [
      {
        disabled: true,
        className: "pointer-events-none",
      },
    ],
  }
)

export interface ItemProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof itemVariants> {
  selected?: boolean
}

const Item = React.forwardRef<HTMLDivElement, ItemProps>(
  ({ className, variant, disabled, selected, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          itemVariants({ variant, disabled }),
          selected && "data-[state=selected]",
          className
        )}
        data-state={selected ? "selected" : undefined}
        {...props}
      />
    )
  }
)
Item.displayName = "Item"

export { Item, itemVariants }
